import { render } from "./ModalWallet.vue?vue&type=template&id=ed621fea&scoped=true"
import script from "./ModalWallet.vue?vue&type=script&lang=js"
export * from "./ModalWallet.vue?vue&type=script&lang=js"

import "./ModalWallet.vue?vue&type=style&index=0&id=ed621fea&lang=scss&scoped=true"
import "./ModalWallet.vue?vue&type=style&index=1&id=ed621fea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed621fea"]])

export default __exports__